export default __webpack_public_path__ + "static/media/PC-05.4e54f8ab.jpg";